import React, { useState } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, c as _slicedToArray, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import { S as SmallText } from './index-f96168ba.js';
import { _ as _isString } from './isString-30e5fe84.js';

var positionType = PropTypes.oneOf(['bottom', 'left', 'right', 'top']);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var ChildrenContainer = styled.div(_templateObject());

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled.div(_templateObject$1());

// @noSnapshot

var getStyle = function getStyle(_ref) {
  var theme = _ref.theme;
  var _theme$components = theme.components,
      components = _theme$components === void 0 ? {} : _theme$components,
      _theme$borders = theme.borders,
      borders = _theme$borders === void 0 ? {} : _theme$borders,
      _theme$colors = theme.colors,
      colors = _theme$colors === void 0 ? {} : _theme$colors,
      _theme$spaces = theme.spaces,
      spaces = _theme$spaces === void 0 ? {} : _theme$spaces;
  var full = spaces.full,
      halt = spaces.halt,
      s0_5 = spaces.s0_5;
  var transparent = colors.transparent;
  var bw8 = borders.widths.bw8;
  var background = components.tooltip.colors.background;
  return css(["top:", ";left:", ";padding-top:", ";transform:translateX(-", ");&::after{border-left:", " solid ", ";border-right:", " solid ", ";border-bottom:", " solid ", ";top:0;left:", ";transform:translateX(-", ");}"], full, halt, s0_5, halt, bw8, transparent, bw8, transparent, bw8, background, halt, halt);
};

var BubbleBottom = css(["", ""], getStyle);

// @noSnapshot

var getStyle$1 = function getStyle(_ref) {
  var theme = _ref.theme;
  var _theme$components = theme.components,
      components = _theme$components === void 0 ? {} : _theme$components,
      _theme$borders = theme.borders,
      borders = _theme$borders === void 0 ? {} : _theme$borders,
      _theme$colors = theme.colors,
      colors = _theme$colors === void 0 ? {} : _theme$colors,
      _theme$spaces = theme.spaces,
      spaces = _theme$spaces === void 0 ? {} : _theme$spaces;
  var full = spaces.full,
      halt = spaces.halt,
      s0_5 = spaces.s0_5;
  var transparent = colors.transparent;
  var bw8 = borders.widths.bw8;
  var background = components.tooltip.colors.background;
  return css(["right:", ";top:", ";padding-right:", ";transform:translateY(-", ");&::after{border-bottom:", " solid ", ";border-top:", " solid ", ";border-left:", " solid ", ";right:0;top:", ";transform:translateY(-", ");}"], full, halt, s0_5, halt, bw8, transparent, bw8, transparent, bw8, background, halt, halt);
};

var BubbleLeft = css(["", ""], getStyle$1);

// @noSnapshot

var getStyle$2 = function getStyle(_ref) {
  var theme = _ref.theme;
  var _theme$components = theme.components,
      components = _theme$components === void 0 ? {} : _theme$components,
      _theme$borders = theme.borders,
      borders = _theme$borders === void 0 ? {} : _theme$borders,
      _theme$colors = theme.colors,
      colors = _theme$colors === void 0 ? {} : _theme$colors,
      _theme$spaces = theme.spaces,
      spaces = _theme$spaces === void 0 ? {} : _theme$spaces;
  var full = spaces.full,
      halt = spaces.halt,
      s0_5 = spaces.s0_5;
  var transparent = colors.transparent;
  var bw8 = borders.widths.bw8;
  var background = components.tooltip.colors.background;
  return css(["left:", ";top:", ";padding-left:", ";transform:translateY(-", ");&::after{border-bottom:", " solid ", ";border-top:", " solid ", ";border-right:", " solid ", ";left:0;top:", ";transform:translateY(-", ");}"], full, halt, s0_5, halt, bw8, transparent, bw8, transparent, bw8, background, halt, halt);
};

var BubbleRight = css(["", ""], getStyle$2);

// @noSnapshot

var getStyle$3 = function getStyle(_ref) {
  var theme = _ref.theme;
  var _theme$components = theme.components,
      components = _theme$components === void 0 ? {} : _theme$components,
      _theme$borders = theme.borders,
      borders = _theme$borders === void 0 ? {} : _theme$borders,
      _theme$colors = theme.colors,
      colors = _theme$colors === void 0 ? {} : _theme$colors,
      _theme$spaces = theme.spaces,
      spaces = _theme$spaces === void 0 ? {} : _theme$spaces;
  var full = spaces.full,
      halt = spaces.halt,
      s0_5 = spaces.s0_5;
  var transparent = colors.transparent;
  var bw8 = borders.widths.bw8;
  var background = components.tooltip.colors.background;
  return css(["bottom:", ";left:", ";padding-bottom:", ";transform:translateX(-", ");&::after{border-left:", " solid ", ";border-right:", " solid ", ";border-top:", " solid ", ";bottom:0;left:", ";transform:translateX(-", ");}"], full, halt, s0_5, halt, bw8, transparent, bw8, transparent, bw8, background, halt, halt);
};

var BubbleTop = css(["", ""], getStyle$3);

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: none;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var positionBubbleStyle = function positionBubbleStyle(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position;

  switch (position) {
    case 'bottom':
      return BubbleBottom;

    case 'left':
      return BubbleLeft;

    case 'right':
      return BubbleRight;

    case 'top':
      return BubbleTop;

    default:
      return BubbleTop;
  }
};

var getTextPosition = function getTextPosition(_ref2) {
  var _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? 'top' : _ref2$position;

  switch (position) {
    case 'bottom':
    case 'top':
      return 'center';

    case 'left':
      return 'right';

    case 'right':
      return 'left';

    default:
      return 'center';
  }
};

var baseBubbleStyle = function baseBubbleStyle(_ref3) {
  var theme = _ref3.theme,
      _ref3$zIndex = _ref3.zIndex,
      zIndex = _ref3$zIndex === void 0 ? '10' : _ref3$zIndex;
  var _theme$components$too = theme.components.tooltip.spaces,
      spaces = _theme$components$too === void 0 ? {} : _theme$components$too;
  return css(["max-width:", ";min-width:", ";position:absolute;text-align:", ";z-index:", ";&::after{content:'';position:absolute;}"], spaces.maxWidth, spaces.minWidth, getTextPosition, zIndex);
};

var animationStyle = function animationStyle(_ref4) {
  var showTooltip = _ref4.showTooltip,
      theme = _ref4.theme;
  var _theme$components$too2 = theme.components.tooltip.animations,
      animations = _theme$components$too2 === void 0 ? {} : _theme$components$too2;
  var opacityEnd = animations.opacityEnd,
      opacityStart = animations.opacityStart,
      speed = animations.speed;
  return css(["opacity:", ";transition:opacity ", ";"], showTooltip ? opacityEnd : opacityStart, speed);
};

var Bubble = styled('div')(_templateObject$2(), animationStyle, baseBubbleStyle, positionBubbleStyle);
Bubble.defaultProps = {
  position: 'top',
  showTooltip: false,
  zIndex: '10'
};
Bubble.propTypes = {
  /* The position of the tooltip's bubble around the children. */
  position: positionType,

  /* Show the tooltip ? */
  showTooltip: PropTypes.bool,

  /* z-index of the tooltip. Defaults to 10. */
  zIndex: PropTypes.string
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var messageThemeStyle = function messageThemeStyle(_ref) {
  var theme = _ref.theme;
  var _theme$components$too = theme.components.tooltip,
      _theme$components$too2 = _theme$components$too.borders,
      borders = _theme$components$too2 === void 0 ? {} : _theme$components$too2,
      _theme$components$too3 = _theme$components$too.colors,
      colors = _theme$components$too3 === void 0 ? {} : _theme$components$too3,
      _theme$components$too4 = _theme$components$too.spaces,
      spaces = _theme$components$too4 === void 0 ? {} : _theme$components$too4;
  return css(["background-color:", ";border-radius:", ";color:", ";padding:", ";"], colors.background, borders.radius, colors.text, spaces.padding);
};

var Message = styled(SmallText)(_templateObject$3(), messageThemeStyle);

function _templateObject$4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      message = _ref.message,
      position = _ref.position,
      rest = _objectWithoutProperties(_ref, ["children", "message", "position"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  return React.createElement(Container, _extends({
    onMouseLeave: function onMouseLeave() {
      setShow(false);
    }
  }, rest), React.createElement(Bubble, {
    position: position,
    showTooltip: show
  }, React.createElement(Message, {
    as: !_isString(message) && 'div'
  }, message)), React.createElement(ChildrenContainer, {
    onMouseOver: function onMouseOver() {
      setShow(true);
    },
    onFocus: function onFocus() {
      setShow(true);
    }
  }, children));
};

Tooltip.defaultProps = {
  position: 'top'
};
Tooltip.propTypes = {
  /* The children on which the tooltip will be displayed over. */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,

  /* The message to display in the tooltip. */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,

  /* The position of the tooltip around the children. */
  position: positionType
};
/*
 * You can have access to this styled-component to use it as a CSS selector,
 * in case you want to change the inner display of the tooltip's message.
 */

Tooltip.Message = Message;
/** @component */

var index = styled(Tooltip)(_templateObject$4());

export default index;
